import React from "react";
import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  
  const [ uiConfig ] = useRecoilState(uiConfigAtom)

  return (
    <div className="flex justify-center items-center my-4 space-x-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className='text-customOne font-bold text-md cursor-pointer'
        style={{backgroundColor: uiConfig?.button?.btnBgColor?.hex}}
      >
        {'< Prev'}
      </button>
      <span>
       <span className="bg-customOne py-1 px-2 rounded-md text-white">{currentPage}</span> 
        {/* of <span className="bg-customOne py-1 px-2 rounded-md text-white">{totalPages}</span> */}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className='text-customOne font-bold text-md cursor-pointer'
        style={{backgroundColor: uiConfig?.button?.btnBgColor?.hex}}
      >
        {'Next >'}
      </button>
    </div>
  );
};

export default Pagination;
